import Model3DModalRedux from './Model3DModalRedux';

export default Model3DModalRedux;